import titleToSectionKey from '../../titleToSectionKeyDict';

export const sectionsSet = new Set([
  'personalInfo',
  'education',
  'skills',
  'projects',
  'workExperience',
  'awardsAndHonors',
  'volunteerWork',
  'certifications',
  'hobbiesAndInterests',
  'leadership',
  'associations',
  'publications',
  'languages',
  'courses',
  'conferences',
  'patents',
  'testScores',
  'references',
  'summary',
]);

export const sectionsDict = {
  'Personal Info': {
    title: 'Personal Info',
    toExport: {
      full_name: false,
      tagline: false,
      email: false,
      phone_number: false,
      personal_link: false,
      address: false,
      objective: false,
    },
    warning: false,
    defaultSection: true,
  },
  Education: {
    title: 'Education',
    toExport: true,
    warning: false,
  },
  Skills: {
    title: 'Skills',
    toExport: true,
    warning: false,
  },
  Projects: {
    title: 'Projects',
    toExport: false,
    warning: false,
  },
  'Work Experience': {
    title: 'Work Experience',
    toExport: true,
    warning: false,
  },
  'Awards & Honors': {
    title: 'Awards & Honors',
    toExport: false,
    warning: false,
  },
  'Volunteer Work': {
    title: 'Volunteer Work',
    toExport: false,
    warning: false,
  },
  Certifications: {
    title: 'Certifications',
    toExport: false,
    warning: false,
  },
  'Hobbies & Interests': {
    title: 'Hobbies & Interests',
    toExport: false,
    warning: false,
  },
  Leadership: {
    title: 'Leadership',
    toExport: false,
    warning: false,
  },
  Associations: {
    title: 'Associations',
    toExport: false,
    warning: false,
  },
  Publications: {
    title: 'Publications',
    toExport: false,
    warning: false,
  },
  Languages: {
    title: 'Languages',
    toExport: false,
    warning: false,
  },
  Courses: {
    title: 'Courses',
    toExport: false,
    warning: false,
  },
  'Conferences/Presentations': {
    title: 'Conferences/Presentations',
    toExport: false,
    warning: false,
  },
  Patents: {
    title: 'Patents',
    toExport: false,
    warning: false,
  },
  'Test Scores': {
    title: 'Test Scores',
    toExport: false,
    warning: false,
  },
  References: {
    title: 'References',
    toExport: false,
    warning: false,
  },
  Summary: {
    title: 'Summary',
    toExport: false,
    warning: false,
  },
};

export const difference = (setA, setB) => {
  const dff = new Set(setA);
  setB.forEach((elem) => {
    dff.delete(elem);
  });
  return dff;
};

export const getEvaluatedSet = (unUsed, used) => {
  const currSectionsSet = new Set();

  unUsed.forEach(({ title, sectionKey }) => {
    currSectionsSet.add(sectionKey || titleToSectionKey[title]);
  });

  used.forEach(({ title, sectionKey }) => {
    currSectionsSet.add(sectionKey || titleToSectionKey[title]);
  });
  return difference(sectionsSet, currSectionsSet);
};
